
import { defineComponent } from 'vue';
import Footer from '../../../components/Frontend/Footer.vue';

import { mdiChevronUp } from '@mdi/js';

export default defineComponent({
  meta: {
    de: {
      title: 'Impressum | Styria Media Group',
      keywords: ['imprint', 'impressum', 'styria media group', 'styria'],
      description: 'Impressum. Styria Media Group AG, Gadollaplatz 1 8010 Graz',
      image: require('@/assets/img/og/startseite.png'),
    },
    en: {
      title: 'Imprint | Styria Media Group',
      keywords: ['imprint', 'styria media group', 'styria'],
      description: 'Imprint. Styria Media Group AG, Gadollaplatz 1 8010 Graz',
      image: require('@/assets/img/og/startseite.png'),
    },
  },
  components: {
    Footer,
  },
  setup() {
    return {
      mdiChevronUp,
    };
  },
});
